
















































































































































































































































































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup, Notify } from "vant";
import axios from "axios";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class NewSentence extends Vue {
  @Prop() show!: any;
  @Prop() words!: any;
  @Prop() wordLevel!: any;
  @Prop() CategoryId!: any;
  @Prop() Day!: any;
  newSynonyms = "";
  newAntonyms = "";
  newExample = "";
  newFalseOption = "";
  errors: any = [];
  @Emit("UpdateWords")
  UpdateWords() {
    return this.wordLevel;
  }

  @Emit("UpdateDayWord")
  UpdateDayWord(words: any) {
    return words;
  }
  @Emit("wordList")
  wordList() {
    return this.words;
  }
  new_word: any = {
    en: null,
    bn: null,
    phBn: null,
    toEn: null,
    partsOfSpeech: null,
    presentForm: null,
    pastForm: null,
    pastParticipleForm: null,
    description: null,
    synonyms: [],
    antonyms: [],
    imageUrl: null,
    mockFalseOptions: [],
    examples: [],
  };
  AddSynonym() {
    if (this.newSynonyms != "") {
      this.new_word.synonyms.push(this.newSynonyms);
    }
    this.newSynonyms = "";
  }
  RemoveSynonym(synIndex: any) {
    this.$delete(this.new_word.synonyms, synIndex);
  }
  AddFalseOption() {
    if (this.newFalseOption != "") {
      this.new_word.mockFalseOptions.push(this.newFalseOption);
    }
    this.newFalseOption = "";
  }
  RemoveFalseOption(optIndex: any) {
    this.$delete(this.new_word.mockFalseOptions, optIndex);
  }
  AddAntonyms() {
    if (this.newAntonyms != "") {
      this.new_word.antonyms.push(this.newAntonyms);
    }
    this.newAntonyms = "";
  }
  RemoveAntonyms(anIndex: any) {
    this.$delete(this.new_word.antonyms, anIndex);
  }

  AddExamples() {
    if (this.newExample != "") {
      this.new_word.examples.push(this.newExample);
    }
    this.newExample = "";
  }
  RemoveExamples(exIndex: any) {
    this.$delete(this.new_word.examples, exIndex);
  }

  checkRequired() {
    if (this.new_word.en && this.new_word.bn && this.new_word.partsOfSpeech) {
      return true;
    }
    this.errors = [];
    if (!this.new_word.en) {
      this.errors.push("word required.");
    }
    if (!this.new_word.bn) {
      this.errors.push("bangla word required.");
    }

    if (!this.new_word.partsOfSpeech) {
      this.errors.push("Parts Of Speech required.");
    }
  }
  AddNewWord() {
    if (this.checkRequired()) {
      if (this.$route.name == "main.word_of_the_month") {
        this.words[this.Day].words.push({
          en: this.new_word.en,
          bn: this.new_word.bn,
          translationType: "EN_2_BN",
          toEn: this.new_word.toEn,
          description: this.new_word.description,
          partsOfSpeech: this.new_word.partsOfSpeech,
          presentForm: this.new_word.presentForm,
          pastForm: this.new_word.pastForm,
          pastParticipleForm: this.new_word.pastParticipleForm,
          synonyms: this.new_word.synonyms,
          antonyms: this.new_word.antonyms,
          examples: this.new_word.examples,
          mockFalseOptions: this.new_word.mockFalseOptions,
          imageUrl: this.new_word.imageUrl,
        });

        this.UpdateDayWord(this.words[this.Day].words);
        // this.AddInDay();
        this.MakeNull();
      } else if (this.$route.name == "main.dictionary") {
        console.warn(this.words);
        this.AddInDictionary();
        this.words.push({
          en: this.new_word.en,
          bn: this.new_word.bn,
          translationType: "EN_2_BN",
          toEn: this.new_word.toEn,
          description: this.new_word.description,
          partsOfSpeech: this.new_word.partsOfSpeech,
          presentForm: this.new_word.presentForm,
          pastForm: this.new_word.pastForm,
          pastParticipleForm: this.new_word.pastParticipleForm,
          synonyms: this.new_word.synonyms,
          antonyms: this.new_word.antonyms,
          mockFalseOptions: this.new_word.mockFalseOptions,
          examples: this.new_word.examples,
          imageUrl: this.new_word.imageUrl,
        });
        window.scrollTo(0, document.body.scrollHeight);

        this.MakeNull();
      } else {
        this.wordLevel.words.push({
          id: "",
          en: this.new_word.en,
          bn: this.new_word.bn,
          translationType: "EN_2_BN",
          toEn: this.new_word.toEn,
          description: this.new_word.description,
          partsOfSpeech: this.new_word.partsOfSpeech,
          presentForm: this.new_word.presentForm,
          pastForm: this.new_word.pastForm,
          pastParticipleForm: this.new_word.pastParticipleForm,
          synonyms: this.new_word.synonyms,
          antonyms: this.new_word.antonyms,
          examples: this.new_word.examples,
          mockFalseOptions: this.new_word.mockFalseOptions,
          imageUrl: this.new_word.imageUrl,
          isBookmarked: false,
          wordCategoryId: "",
          isUserGenerated: false,
          agreedToContribute: false,
          bookmarkCategoryName: "",

          frequency: 0,
          weight: 0,
        });
        window.scrollTo(0, document.body.scrollHeight);
        this.UpdateWords();
        this.MakeNull();
      }
    }
    // word.whoBn = word.whoEn = word.sentenceBn = word.sentenceEn = "";
  }
  MakeNull() {
    this.new_word.en = null;
    this.new_word.bn = null;
    this.new_word.phBn = null;
    this.new_word.partsOfSpeech = null;
    this.new_word.presentForm = null;
    this.new_word.pastForm = null;
    this.new_word.pastParticipleForm = null;
    this.new_word.description = null;
    this.new_word.synonyms = [];
    this.new_word.antonyms = [];
    this.new_word.imageUrl = null;
    this.new_word.examples = [];
    this.new_word.mockFalseOptions = [];
  }

  AddInDictionary() {
    const data = {
      word: {
        en: this.new_word.en,
        bn: this.new_word.bn,
        toEn: this.new_word.toEn,
        translationType: "EN_2_BN",
        description: this.new_word.description,
        partsOfSpeech: this.new_word.partsOfSpeech,
        presentForm: this.new_word.presentForm,
        pastForm: this.new_word.pastForm,
        pastParticipleForm: this.new_word.pastParticipleForm,
        synonyms: this.new_word.synonyms,
        antonyms: this.new_word.antonyms,
        mockFalseOptions: this.new_word.mockFalseOptions,
        examples: this.new_word.examples,
        imageUrl: this.new_word.imageUrl,
      },
    };

    const response = axios
      .post("https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/AddWord", data)
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Word is not added" });
      });
    this.wordList();
    Notify({ type: "success", message: "Word is added" });
  }

  showPopup() {
    this.show = true;
  }
  partsOfSpeech = [
    "Noun",
    "Pronoun",
    "Verb",
    "Adjective",
    "Adverb",
    "Preposition",
    "Conjunction",
    "Interjenction",
  ];
}
